import { LDContext } from 'launchdarkly-js-client-sdk';
import { getHostName } from '../../../utils/getHostName';

const LDClient = process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID ?? '';

export const CONTEXT: LDContext = {
  key: 'anonymous',
  custom: {
    hostName: getHostName(),
    pathName: window.location.pathname,
  },
};

export const LAUNCHDARKLY_CLIENT_ID = LDClient;
export const LAUNCHDARKLY_APP_TYPE = 'web';

export const LDCustomLogger = {
  debug() {},
  info() {},
  warn(message: string) {
    console.warn(message);
  },
  error(message: string) {
    console.error(message);
  },
};
